import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'apps/artisan/src/environments/environment';
import { Observable } from 'rxjs';
import {
  OktaLoginRequest,
  forgotPasswordType,
  resetPasswordType,
  validateSessionIdType,
  GlobalVariablesService,
  GoogleAnalyticResponse,
  updateEmailType,
  updatePhoneType,
  updatePasswordType,userFeatureRequest
} from '@tmhcc-ng-lib/data-service';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import { OktaConfig } from '@okta/okta-angular';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { appendRelativePathToUrl } from '@tmhcc/util';

@Injectable({
  providedIn: 'root'
})
export class OktaLoginService extends BaseDataService {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    @Inject(OKTA_CONFIG) protected configs: OktaConfig,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  verifyOkta(params: OktaLoginRequest): Observable<any> {
    const url = this.getServiceUrl('authentication/verify-okta');
    return this.post<OktaLoginRequest>(url, { body: params }, false, false);
  }

  processOkta(params: OktaLoginRequest): Observable<any> {
    const url = this.getServiceUrl('authentication/process-okta');
    return this.post<OktaLoginRequest>(url, { body: params }, false, false);
  }

  loginOkta(params: OktaLoginRequest): Observable<any> {
    const url = this.getServiceUrl('authentication/login-okta');
    //const url = "http://localhost:51806/authentication/login-okta";
    return this.post<OktaLoginRequest>(url, { body: params }, false, false);
  }

  forgotPassword(params: forgotPasswordType): Observable<any> {
    const url = this.getServiceUrl('authentication/forgot-password');
    return this.post<forgotPasswordType>(url, { body: params }, false, false);
  }

  resetPassword(params: resetPasswordType): Observable<any> {
    const url = this.getServiceUrl('authentication/reset-password');
    return this.post<resetPasswordType>(url, { body: params }, false, false);
  }

  updateEmail(params: updateEmailType): Observable<any> {
    const url = this.getServiceUrl('authentication/update-email');
    //const url = "http://localhost:51806/authentication/update-email";
    return this.post<updateEmailType>(url, { body: params }, false, true);
  }

  updatePhone(params: updatePhoneType): Observable<any> {
    const url = this.getServiceUrl('authentication/update-phone');
    //const url = "http://localhost:51806/authentication/update-phone";
    return this.post<updatePhoneType>(url, { body: params }, false, true);
  }

  updatePassword(params: updatePasswordType): Observable<any> {
    const url = this.getServiceUrl('authentication/update-password');
    //const url = "http://localhost:51806/authentication/update-password";
    return this.post<updatePasswordType>(url, { body: params }, false, true);
  }

  validateSessionId(params: validateSessionIdType): Observable<any> {
    const url = this.getServiceUrl(
      'authentication/validate-session-id/' + params.logininfo
    );
    return this.get<validateSessionIdType>(url, null, false, false, true);
  }

  // showBoostaiChatSessionId(user: string): Observable<any> {
  //   const url = this.getServiceUrl(
  //     'authentication/verify-user-feature-enabled/' +user)
  //   //const url = "http://localhost:51806/authentication/update-password";s
  //   return this.get<userFeatureRequest>(url, null,true, true, true);
  // }
 

  getServiceUrl(servicePath: string): string {
    return appendRelativePathToUrl(
      environment.oktaWidgetConfig.issuer,
      servicePath
    );
  }

  isAuthenticated() {
    const token = sessionStorage.getItem('token');
    if (token) {
      return true;
    }
  }
  getUser() {
    const userId = sessionStorage.getItem('user');
    if (userId) {
      return userId;
    }
  }
}
